import { Skeleton } from "@mui/material";

function ChartSkeleton() {
  return <Skeleton animation='wave' />;
}

export default ChartSkeleton;
